import * as React from "react";
import {Button, Col, Row, Tabs} from "antd";
import {withTranslation, WithTranslation} from 'react-i18next'
import ProjectTemplateList from "./projects/project-template-list";
import autobind from 'autobind-decorator'
import EditableTooltip from '../../../components/editable-tooltip/tooltip';
import Tour from 'reactour';
import steps from 'src/components/virtual-tour/virtual-tour-configs';
import { WrapperTaskTemplateTable } from "./tasks/WrapperTaskTemplateTable";


// tslint:disable-next-line:no-empty-interface
interface TemplatesTabViewProps extends WithTranslation {
    companyId: string,
    companyName: string,
    companyAllowCir: boolean,
    companyAllowCii: boolean,
    refresh?: boolean,
    onRefresh?: () => void;
}

interface TemplatesTabViewState {
    isTourOpen: boolean,
    currentStep: number,
    activeTab: string,
}

class TemplatesTabView extends React.Component<TemplatesTabViewProps, TemplatesTabViewState> {
    constructor(props: TemplatesTabViewProps) {
        super(props);
        this.state = {
            isTourOpen: false,
            currentStep: 0,
            activeTab: "project-templates",
        }
    }

    @autobind
    private setIsTourOpen(state: boolean) {
        if (!state) {
            this.setState({ currentStep: 0 })
        }
        this.setState({ isTourOpen: state });

    }
    @autobind
    private onIconClick(state: boolean) {
        this.setState({ currentStep: 1 });
        this.setState({ isTourOpen: true });
    }

    @autobind
    private onTabChange(tabKey: string) {
        this.setState({ activeTab: tabKey })
    }

    public render() {
        const { t, companyId, companyName } = this.props;
        return (<div>
            <Row gutter={0} >
                <Col span={12}>
                    {
                        this.state.activeTab == "project-templates" &&
                        < Tour

                            steps={steps(t).stepsTemplates}
                            isOpen={this.state.isTourOpen}
                            onRequestClose={() => this.setIsTourOpen(false)}
                            startAt={this.state.currentStep}
                        />
                    }
                    {
                        this.state.activeTab == "task-templates" &&
                        < Tour
                            steps={steps(t).stepsTemplates2}
                            isOpen={this.state.isTourOpen}
                            onRequestClose={() => this.setIsTourOpen(false)}
                            startAt={this.state.currentStep}
                        />
                    }
                </Col>
                <Col span={12}>
                    <Button data-tut="reactour__templateInit" type={"link"} style={{ float: 'right', marginBottom: 5 }} onClick={() => this.setIsTourOpen(true)} icon={'caret-right-fill'}>  {t("Discover Templates")} </Button>
                </Col>
            </Row>
            <div >
                <Tabs tabPosition={"left"} activeKey={this.state.activeTab} onChange={this.onTabChange}>
                    <Tabs.TabPane key="project-templates" tab={<div data-tut="reactour__navegateTemplate"><EditableTooltip onClickIcon={this.onIconClick} name="template-projects">{t("Projects")}</EditableTooltip></div>}>
                        <ProjectTemplateList companyId={companyId} companyName={companyName} />
                    </Tabs.TabPane>
                    <Tabs.TabPane key="task-templates" tab={<div data-tut="reactour__navegateTemplate2"><EditableTooltip onClickIcon={this.onIconClick} name="template-tasks">{t("Tasks")}</EditableTooltip></div>}>
                        <WrapperTaskTemplateTable
                            companyId={companyId}
                            companyAllowCir={this.props.companyAllowCir}
                            companyAllowCii={this.props.companyAllowCii}
                            refresh={this.props.refresh}
                            onRefresh={this.props.onRefresh}
                        />
                    </Tabs.TabPane>

                </Tabs>
            </div>
        </div>)
    }
}

// Wire up the React component to the Redux store
export default withTranslation()(TemplatesTabView);
